// this creates an array that holds all the images from the assets/gallery-photos folder

function importAllGeneralGalleryImages(r) {
    return r.keys().map(r);
  }
  //the array...
  const generalGalleryImages  = importAllGeneralGalleryImages(require.context('../../../assets/gallery-photos/', false, /\.(png|jpe?g|svg)$/))

    export default generalGalleryImages